import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { getAllColors } from "../../services/color.service";
import { useSelector } from "react-redux";
import { addProduct } from "../../services/product.service";
import { getAllMainCategories } from "../../services/category.service";
import { getAllBrands } from "../../services/brand.service";
import { getAllSubCategories } from "../../services/subcategory.service";

export default function ProductAdd() {
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [designNumbers, setDesignNumbers] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [brands, setBrands] = useState([]);
  const [colors, setColors] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const { token } = useSelector((state) => state?.auth);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    watch,
    clearErrors,
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmitDesignNumber,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();

  const fetchColors = async () => {
    try {
      const res = await getAllColors(token);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res);
        
        setColors(res.data);
      } else {
        Swal.fire("Error", "Failed to fetch colors.", "error");
      }
    } catch (error) {
      console.error("Error fetching colors:", error);
      Swal.fire("Error", "Network or server error occurred.", "error");
    }
  };

  const fetchBrands = async (page = false) => {
    try {
      const params = { page };
      const res = await getAllBrands(token, params);
      if (res && res.status >= 200 && res.status < 300) {
        setBrands(res?.data);
        fetchSubCategories()
        fetchColors()
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch Brands. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching Brands:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const fetchSubCategories = async (page = false) => {
    try {
      const params = { page };
      const res = await getAllSubCategories(token, params);
      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res);
        
        setSubCategories(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message ||
            "Failed to fetch subcategories. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchBrands();
    fetchSubCategories();
    fetchColors();
  }, []);

  const onSubmit = async (item) => {
    setIsLoading2(true);

    const data = {
      product_name: item.productName,
      brand: item.brand,
      category: item.subCategory,
      product_design_number: designNumbers,
      fabric: item.fabric,
      pcs_in_set: item.piecesInSet,
      assorted: item.assorted === "True",
      assorted_pcs_in_set: item.assortedValue,
      colors:
        selectedColors?.length > 0
          ? selectedColors.map((color) => color.value)
          : null,
      in_stock: item.inStock === "True",
      image: item.image,
      description: item.description,
    };

    // console.log("data", data);

    try {
      const res = await addProduct(token, data);
      // console.log(res);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Added!",
          text: `${item.productName} Product has been added successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/products");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.message || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during adding brand:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  const onSubmitDesignNumber = (item) => {
    const delimiters = /[,\s|;:/]+/;
    const newDesignNumbers = item.designNumber
      .split(delimiters)
      .map((num) => num.trim())
      .filter((num) => num !== "");

    if (newDesignNumbers.length > 0) {
      setDesignNumbers((prev) => {
        const uniqueNumbers = [...new Set([...prev, ...newDesignNumbers])];

        setValue("designNumber1", uniqueNumbers.join(", "));
        clearErrors("designNumber1");

        return uniqueNumbers;
      });
    }
    document.getElementById("designModalClose").click();
    reset2();
  };

  const deleteDesignNumber = (number) => {
    setDesignNumbers((prev) => prev.filter((item) => item !== number));
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     if (
  //       ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
  //         file.type
  //       )
  //     ) {
  //       setImagePreview(URL.createObjectURL(file));
  //       clearErrors("image");
  //     } else {
  //       setError("image", {
  //         type: "manual",
  //         message: "Only JPEG, PNG, or JPG files are allowed",
  //       });
  //     }
  //   }
  // };

     const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
          file.type
        )
      ) {
        if (file.size < 1 * 1024 * 1024) {
          setImagePreview(URL.createObjectURL(file));
          clearErrors("image");
        } else {
          setError("image", {
            type: "manual",
            message: "Image size must be less than 1MB.",
          });
          setImagePreview(null)
          setValue("image", null);
        }
      } else {
        setError("image", {
          type: "manual",
          message: "Only JPEG, PNG, JPG, or WEBP files are allowed.",
        });
        setImagePreview(null)
        setValue("image", null);
      }
    }
  };

  const brandOptions = useMemo(
    () => [
      ...brands.map((brand) => ({
        value: brand.brand_id,
        label: brand.brand_name,
        acronym: brand.acronym,
      })),
      { value: "addBrand", label: "Add Brand", isAddOption: true },
    ],
    [brands]
  );

  // const subCategoryOptions = useMemo(
  //   () => [
  //     ...subCategories.map((category) => ({
  //       value: category.sub_category_id,
  //       label: `${category.sub_category_name} (${category.main_category_name})`,
  //     })),
  //     { value: "addSubCategory", label: "Add Sub Category", isAddOption: true },
  //   ],
  //   [brands]
  // );

  const subCategoryOptions = [
    ...subCategories?.map((category) => ({
      value: category.sub_category_id,
      label: `${category.sub_category_name} (${category.main_category_name})`,
    })),
    { value: "addSubCategory", label: "Add Sub Category", isAddOption: true },
  ];
  
  // const subCategoryOptions = subCategories.map((category) => {
  //   return {
  //     value: category.sub_category_id,
  //     label: `${category.sub_category_name} (${category.main_category_name})`,
  //   };
  // });
  
  // subCategoryOptions.push({
  //   value: "addSubCategory",
  //   label: "Add Sub Category",
  //   isAddOption: true,
  // });
  



  const handleBrandChange = (selectedOption) => {
    // console.log(selectedOption);
    if (selectedOption?.value === "addBrand") {
      navigate("/brands/add");
    } else {
      setValue("brand", selectedOption?.value);
      clearErrors("brand");
    }
  };

  const handleSubCategoryChange = (selectedOption) => {
    // console.log(selectedOption);
    if (selectedOption?.value === "addSubCategory") {
      navigate("/sub-categories/add");
    } else {
      setValue("subCategory", selectedOption?.value);
      clearErrors("subCategory");
    }
  };

  const customStyles = {
    option: (provided, state) => {
      if (state.data.isAddOption) {
        return {
          ...provided,
          backgroundColor: "#4baebc",
          fontWeight: "bold",
          color: "white",
          cursor: "pointer",
        };
      }
      return provided;
    },
  };

  const customFilterOption = (candidate, input) => {
    // console.log(candidate);

    if (candidate.data.isAddOption) {
      return true;
    }
    return candidate?.label?.toLowerCase().includes(input.toLowerCase());
  };

  return (
    <div className="content-body">
      {/* Modal for Adding Design Number */}
      <div
        className="modal fade"
        id="addDesignNumberModal"
        tabIndex="-1"
        aria-labelledby="addDesignNumberModalTitle"
        aria-hidden="true"
        // style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addDesignNumberModalTitle">
                Add Design Number
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="designModalClose"
              ></button>
            </div>
            <form onSubmit={handleSubmitDesignNumber(onSubmitDesignNumber)}>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Design Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter design number"
                    {...register2("designNumber", {
                      required: "Design number is required",
                    })}
                  />
                  {errors2.designNumber && (
                    <p className="error text-danger">
                      {errors2.designNumber.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">
                  ADD DESIGN
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* End Modal */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Product</h4>
                <Link to="/products">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body py-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    {/* Product Name */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Product Name</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter product name"
                        {...register("productName", {
                          required: "Product name is required",
                        })}
                      />
                      {errors.productName && (
                        <p className="error">{errors.productName.message}</p>
                      )}
                    </div>

                    {/* Brand */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Brand</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <Select
                        options={brandOptions}
                        {...register("brand", {
                          required: " brand is required",
                        })}
                        onChange={handleBrandChange}
                        placeholder="Select Brand"
                        isClearable
                        styles={customStyles}
                        filterOption={customFilterOption}
                        value={brands
                          .map((brand) => ({
                            value: brand.brand_id,
                            label: brand.brand_name,
                          }))
                          .find((option) => option.value === watch("brand"))}
                      />
                      {errors.brand && (
                        <p className="error">{errors.brand.message}</p>
                      )}
                    </div>

                    {/* Subcategory */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Sub Category</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <Select
                        options={subCategoryOptions}
                        {...register("subCategory", {
                          required: "Sub Category is required",
                        })}
                        onChange={handleSubCategoryChange}
                        sub_category_name
                        placeholder="Select Sub Category"
                        isClearable
                        styles={customStyles}
                        filterOption={customFilterOption}
                        value={subCategories
                          .map((category) => ({
                            value: category.sub_category_id,
                            label: `${category.sub_category_name} (${category.main_category_name})`,
                            // label: `${category.sub_category_name} (${category.main_category_name})`,
                            // label: category.sub_category_name,
                          }))
                          .find(
                            (option) => option.value === watch("subCategory")
                          )}
                      />
                      {errors.subCategory && (
                        <p className="error">{errors.subCategory.message}</p>
                      )}
                    </div>

                    {/* Design Numbers Input Field */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Design Number</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Design numbers will appear here"
                          data-bs-toggle="modal"
                          data-bs-target="#addDesignNumberModal"
                          value={designNumbers.join(", ")}
                          {...register("designNumber1", {
                            required: "Design number is required",
                          })}
                          readOnly
                        />
                        <button
                          type="button"
                          className="btn btn2 p-1 ps-2"
                          data-bs-toggle="modal"
                          data-bs-target="#addDesignNumberModal"
                          style={{ zIndex: "0" }}
                          // title="Add Design Number"
                        >
                          <img src="/assets/images/kidskart/icon/plus.png" />
                          <span className="tooltip-text mb-1">
                            Add Design Number
                          </span>
                        </button>
                        {designNumbers.length > 0 && (
                          <button
                            type="button"
                            className="btn btn2 p-1"
                            onClick={() => setIsDropdownOpen((prev) => !prev)}
                            style={{ zIndex: "0" }}
                            // title="Delete Design Number"
                          >
                            <img src="/assets/images/kidskart/icon/minus.png" />
                            <span className="tooltip-text mb-1">
                              Delete Design Number
                            </span>
                          </button>
                        )}
                      </div>
                      {errors.designNumber1 && (
                        <p className="error">{errors.designNumber1.message}</p>
                      )}

                      {/* Dropdown for Deleting Design Numbers */}
                      {isDropdownOpen && designNumbers.length > 0 && (
                        <ul className="list-group mt-2">
                          {designNumbers.map((number, index) => (
                            <li
                              key={index}
                              className="list-group-item d-flex justify-content-between align-items-center ps-3 p-1"
                            >
                              {number}
                              <button
                                type="button"
                                className="btn p-0 btn2 py-1"
                                onClick={() => deleteDesignNumber(number)}
                                title="Delete Design Number"
                              >
                                <img src="/assets/images/kidskart/icon/minus.png" />
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    {/* Fabric */}
                    <div className="mb-4 col-md-6">
                      <label className="form-label">Fabric</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter fabric"
                        {...register("fabric")}
                      />
                      {errors.fabric && (
                        <p className="error">{errors.fabric.message}</p>
                      )}
                    </div>

                    {/* Pieces in Set */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Pieces In Set</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter pieces in set"
                        {...register("piecesInSet", {
                          required: "Pieces in set is required",
                        })}
                      />
                      {errors.piecesInSet && (
                        <p className="error">{errors.piecesInSet.message}</p>
                      )}
                    </div>

                    {/* Assorted */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Assorted</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <Select
                        options={[
                          { value: "True", label: "Yes" },
                          { value: "False", label: "No" },
                        ]}
                        {...register("assorted", {
                          required: "Assorted status is required",
                        })}
                        onChange={(selectedOption) => {
                          setValue("assorted", selectedOption?.value);
                          clearErrors("assorted");
                        }}
                        placeholder="Select Assorted or Not"
                        isClearable
                        value={[
                          { value: "True", label: "Yes" },
                          { value: "False", label: "No" },
                        ].find((option) => option.value === watch("assorted"))}
                      />
                      {errors.assorted && (
                        <p className="error">{errors.assorted.message}</p>
                      )}
                    </div>

                    {/* Conditional Input for Assorted Value */}
                    {watch("assorted") === "True" && (
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <div className="d-flex">
                            <label className="form-label">
                              Assorted Pieces in set
                            </label>
                            <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                          </div>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          {...register("assortedValue", {
                            required: "Assorted Pieces in set is required",
                          })}
                          placeholder="Enter assorted Pieces in set"
                        />
                        {errors.assortedValue && (
                          <p className="error">
                            {errors.assortedValue.message}
                          </p>
                        )}
                      </div>
                    )}

                    {/* Colors Multi-select */}

                    <div className="mb-4 col-md-6">
                      <label className="form-label">Colors</label>
                      <Select
                        isMulti
                        options={colors?.map((color) => ({
                          value: color.color_id,
                          label: color.color_name,
                        }))}
                        value={selectedColors}
                        onChange={(selected) => setSelectedColors(selected)}
                      />
                    </div>

                    {/* In Stock */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">In Stock</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <Select
                        options={[
                          { value: "True", label: "Yes" },
                          { value: "False", label: "No" },
                        ]}
                        {...register("inStock", {
                          required: "In stock status is required",
                        })}
                        onChange={(selectedOption) => {
                          setValue("inStock", selectedOption?.value);
                          clearErrors("inStock");
                        }}
                        placeholder="Select Stock Status"
                        isClearable
                        value={[
                          { value: "True", label: "Yes" },
                          { value: "False", label: "No" },
                        ].find((option) => option.value === watch("inStock"))}
                      />
                      {errors.inStock && (
                        <p className="error">{errors.inStock.message}</p>
                      )}
                    </div>

                    {/* Image */}
                    <div className="mb-4 col-md-6">
                      <div className="d-flex">
                        <label className="form-label">Image</label>
                        <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        {...register("image", {
                          required: "Image is required",
                        })}
                        onChange={handleImageChange}
                      />
                      {errors.image && (
                        <p className="error">{errors.image.message}</p>
                      )}
                    </div>

                    {watch("assorted") === "True" ? null : (
                      <div className="mb-4 col-md-6"></div>
                    )}

                    <div className="mb-4 col-md-6">
                      {imagePreview && (
                        <img
                          src={imagePreview}
                          alt="Preview"
                          className="img-thumbnail mt-2"
                          style={{ width: "100px" }}
                        />
                      )}
                    </div>

                    {/* Description */}
                    <div className="mb-4 col-md-12">
                      <label className="form-label">Description</label>
                      <textarea
                        rows="3"
                        className="form-control"
                        placeholder="Enter description"
                        {...register("description")}
                      ></textarea>
                    </div>
                  </div>

                  {!isLoading2 ? (
                    <div className="col-sm-4">
                      <button type="submit" className="btn btn-primary w-100">
                        ADD PRODUCT
                      </button>
                    </div>
                  ) : (
                    <div className="col-sm-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        disabled
                      >
                        ADDING PRODUCT
                      </button>

                      <div
                        className="spinner-border2 text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
